import SimpleBar from "simplebar";

Array.prototype.forEach.call(
    document.querySelectorAll(`[data-mysimplebar]`),
    (el) => {
        let size = 145;

        if (el.dataset.size) {
            size = parseInt(el.dataset.size, 10);
        }

        new SimpleBar(el, {
            autoHide: false,
            scrollbarMinSize: size,
            scrollbarMaxSize: size,
        });
    }
);

const medparts = document.querySelectorAll(".Bluebar__table.medpart");

let resizeTimeout;

const resize = () => {
    medparts.forEach((medpart) => {
        if (medpart.querySelector(".simplebar-wrapper")) {
            const vertScroll = medpart.querySelector(
                ".simplebar-track.simplebar-vertical"
            );

            vertScroll.style.marginTop = `${
                medpart.querySelector("th,.th").getBoundingClientRect().height +
                (innerWidth > 1024 ? 4 : 10)
            }px`;
        }
    });
};

window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resize, 400);
});

resize();
